import { NoonReportSectionEnum } from '../types/BusinessModel/AolEnums';
import { AolSectionDataUpdateDto } from '../types/Dto/AolSectionDataUpdateDto';

export class AolSectionDataUpdateDtoFactory {
    public createDto(
        imoNumber: number,
        noonReportId: number,
        noonReportSectionEnum: NoonReportSectionEnum,
        isAolCompleted: boolean,
        isAolApproved: boolean,
        isSectionCompleted: boolean,
        isSectionApproved: boolean
    ): AolSectionDataUpdateDto {
        return {
            imoNumber: imoNumber,
            noonReportId: noonReportId,
            noonReportSectionEnum: noonReportSectionEnum,
            isAolCompleted: isAolCompleted,
            isAolApproved: isAolApproved,
            isSectionCompleted: isSectionCompleted,
            isSectionApproved: isSectionApproved,
        };
    }
}
